import { Component, OnInit } from '@angular/core';
import { Title }  from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ElasitcService} from '../../servies/elastic/elasitc.service';

@Component({
    selector: 'app-default',
    templateUrl: './sources.component.html',
    styleUrls: []
  })
  export class SourcesComponent implements OnInit {
    sources:any[]=[]
    logged_in_username:string="";
    constructor(private elastic:ElasitcService,private router:Router){
        if(sessionStorage.getItem('loggedin')=='false' || sessionStorage.getItem('loggedin')==null)
        {      
          this.gotoLogin();
        }    
        else if(sessionStorage.getItem('loggedin')=='true'){
          this.logged_in_username= sessionStorage.getItem('loggedinname');
          //this.router.getCurrentNavigation().extras.state.logged_in_user;     
        }
    }
    gotoLogin(){    
        this.router.navigate(['/login']);  // define your component where you want to go
      }
      freeze(name){
        this.elastic.freezeIndex(name).subscribe(data => {
        console.log(data)
        alert("source "+name+" freezed successfully")
        },
        error=>{
            console.log(error)
            alert("Freeze failed..")
        });
      }
      unfreeze(name){
        this.elastic.unfreezeIndex(name).subscribe(data => {
        console.log(data)
        alert("source "+name+" unfreezed successfully")
        },
        error=>{
            console.log(error)
            alert("UnFreeze failed..")
        });
      }
      refresh(name){
        this.elastic.RefreshIndex(name).subscribe(data => {
        console.log(data)
        alert("source "+name+" refreshed successfully")
        },
        error=>{
            console.log(error)
            alert("Refresh failed..")
        });
      }
    getSources(){
        this.elastic.getIndices().subscribe(data => { 
            for(var item in data){
                this.sources.push({
                    'name':data[item].index,
                    'status':data[item].status,
                    'count':data[item]["docs.count"],
                    'size':data[item]["store.size"]
                })

            }
           
        });
        console.log(this.sources)
    }
    ngOnInit(){
      this.getSources()
    }
  }